export default function (api) {
  return {
    setToken (context, token) {
      return api.addTokenToHeader(token)
    },

    login (context, params) {
      return api.post(`${process.env.API_URL}/auth`, params)
       .then(response => context.commit('LOGIN', response.data))
       .catch(error => {
         context.commit('SET_ERROR', error)
         return Promise.reject()
       })
    },

    /**
     * Customer
     */
    getCustomer (context, { customerId, params }) {
      return api.get(`${process.env.API_URL}/customers/${customerId}`, params)
       .then(response => context.commit('SET_CUSTOMER', response.data))
       .catch(error => context.commit('SET_ERROR', error))
    },

    /**
     * Products
     */
    getProduct (context, { productId, params }) {
      return api.get(`${process.env.API_URL}/products/${productId}`, params)
        .then(response => context.commit('SET_PRODUCT', response.data))
        .catch(error => context.commit('SET_ERROR', error))
    },

    getOrganizationProducts (context, { organizationId, params }) {
      return api.get(`${process.env.API_URL}/organizations/${organizationId}/products`, params)
        .then(response => context.commit('SET_PRODUCTS', response.data))
        .catch(error => context.commit('SET_ERROR', error))
    },

    /**
     * Clients
     */
    getClient (context, { clientId, params }) {
      return api.get(`${process.env.API_URL}/clients/${clientId}`, params)
        .then(response => context.commit('SET_CLIENT', response.data))
        .catch(error => context.commit('SET_ERROR', error))
    },

    getOrganizationClients (context, { organizationId, params }) {
      return api.get(`${process.env.API_URL}/organizations/${organizationId}/clients`, params)
        .then(response => context.commit('SET_CLIENTS', response.data))
        .catch(error => context.commit('SET_ERROR', error))
    },

    /**
     * Things
     */
    getThing (context, { thingId, params }) {
      return api.get(`${process.env.API_URL}/things/${thingId}`, params)
        .then(response => context.commit('SET_THING', response.data))
        .catch(error => context.commit('SET_ERROR', error))
    },

    getProductThings (context, { productId, params }) {
      return api.get(`${process.env.API_URL}/products/${productId}/things`, params)
        .then(response => context.commit('SET_PRODUCT_THINGS', response.data))
        .catch(error => context.commit('SET_ERROR', error))
    },

    /**
     * Devices
     */
    getClientDevices (context, { clientId, params }) {
      return api.get(`${process.env.API_URL}/clients/${clientId}/devices`, params)
        .then(response => context.commit('SET_CLIENT_DEVICES', response.data))
        .catch(error => context.commit('SET_ERROR', error))
    },

    /**
     * Firmware updates
     */
    getProductFwUpdates (context, { productId, params }) {
      return api.get(`${process.env.API_URL}/products/${productId}/fw_updates`, params)
        .then(response => context.commit('SET_FW_UPDATES', response.data))
        .catch(error => context.commit('SET_ERROR', error))
    },

    /**
     * Users
     */
    getUser (context, { userId, params }) {
      return api.get(`${process.env.API_URL}/users/${userId}`, params)
       .then(response => context.commit('SET_USER', response.data))
       .catch(error => context.commit('SET_ERROR', error))
    },

    getOrganizationUsers (context, { organizationId, params }) {
      return api.get(`${process.env.API_URL}/organizations/${organizationId}/users`, params)
        .then(response => context.commit('SET_USERS', response.data))
        .catch(error => context.commit('SET_ERROR', error))
    },

    /**
     * Create
     */
    createProduct (context, data) {
      return api.post(`${process.env.API_URL}/products`, data)
        .then(response => context.commit('CREATE_PRODUCT', response))
        .catch(error => {
          context.commit('SET_ERROR', error)
          return Promise.reject()
        })
    },
    createClient (context, data) {
      return api.post(`${process.env.API_URL}/clients`, data)
        .then(response => context.commit('CREATE_CLIENT', response))
        .catch(error => {
          context.commit('SET_ERROR', error)
          return Promise.reject()
        })
    },

    /**
     * Edit
     */
    updateProduct (context, { productId, params }) {
      return api.put(`${process.env.API_URL}/products/${productId}`, params)
        .then(response => context.commit('UPDATE_PRODUCT', response))
        .catch(error => {
          context.commit('SET_ERROR', error)
          return Promise.reject()
        })
    },

    updateClient (context, { clientId, params }) {
      return api.put(`${process.env.API_URL}/clients/${clientId}`, params)
        .then(response => context.commit('UPDATE_CLIENT', response))
        .catch(error => {
          context.commit('SET_ERROR', error)
          return Promise.reject()
        })
    },

    updateThing (context, { thingId, params }) {
      return api.put(`${process.env.API_URL}/things/${thingId}`, params)
        .then(response => context.commit('UPDATE_THING', response))
        .catch(error => {
          context.commit('SET_ERROR', error)
          return Promise.reject()
        })
    },

    updateUser (context, { userId, params }) {
      return api.put(`${process.env.API_URL}/users/${userId}`, params)
        .then(response => context.commit('UPDATE_USER', response))
        .catch(error => {
          context.commit('SET_ERROR', error)
          return Promise.reject()
        })
    },

    /**
     * Upload
     */
    uploadFile (context, data) {
      return api.post(`${process.env.API_URL}/files`, data)
        .then(response => context.commit('UPLOAD_FILE', response))
        .catch(error => {
          context.commit('SET_ERROR', error)
          return Promise.reject()
        })
    },

    saveFwUpdate (context, data) {
      return api.post(`${process.env.API_URL}/fw_updates`, data)
        .then(response => context.commit('SAVE_FW_UPDATE', response))
        .catch(error => {
          context.commit('SET_ERROR', error)
          return Promise.reject()
        })
    },

    /**
     * Delete
     */
    deleteThing (context, thingId) {
      return api.delete(`${process.env.API_URL}/things/${thingId}`)
        .then(response => context.commit('DELETE_THING', response))
        .catch(error => {
          context.commit('SET_ERROR', error)
          return Promise.reject()
        })
    },

    deleteFwUpdate (context, fwUpdateId) {
      return api.delete(`${process.env.API_URL}/fw_updates/${fwUpdateId}`)
        .then(response => context.commit('DELETE_FW_UPDATE', response))
        .catch(error => {
          context.commit('SET_ERROR', error)
          return Promise.reject()
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js